<template>
  <img loading="lazy" :src="resolvedSrc" alt="" />
</template>

<script setup lang="ts">
//@ts-ignore
import { ref } from "vue"

interface IKpImageProps {
  src: string
}

const props = defineProps<IKpImageProps>()

const resolvedSrc = ref<string>("")

resolvedSrc.value = new URL(props.src, import.meta.url).href
</script>

<style scoped lang="scss"></style>
